<div class="p-8 border rounded-lg bg-card">
    <div class="pb-4 border-b">
        <h2 class="text-xl font-semibold">Provide Translation Files</h2>
        <p class="mt-1 text-secondary">Choose your file structure and provide the content.</p>
    </div>

    <mat-button-toggle-group class="mt-6" [(ngModel)]="inputFormat">
        <mat-button-toggle value="separate">Separate Files</mat-button-toggle>
        <mat-button-toggle value="combined">Single Combined File</mat-button-toggle>
    </mat-button-toggle-group>

    <!-- Mode 1: Separate Files -->
    <div *ngIf="inputFormat === 'separate'" [formGroup]="separateFilesForm" class="mt-4">
        <h3 class="text-lg font-medium mt-6">Base Language ({{ wizardData.baseLanguage | uppercase }})</h3>
        <div class="mt-2">
            <textarea matInput class="w-full h-48 p-2 font-mono border rounded-md bg-gray-50 dark:bg-gray-800" formControlName="baseJson" placeholder='{ "GREETING": "Hello" }'></textarea>
            <div class="flex items-center justify-between mt-2">
                <mat-error *ngIf="separateFilesForm.get('baseJson')?.hasError('invalidJson') && separateFilesForm.get('baseJson')?.touched">Invalid JSON format.</mat-error>
                <button mat-button (click)="baseFileInput.click()">Upload File</button>
                <input type="file" #baseFileInput class="hidden" accept=".json" (change)="handleFileInput($event, separateFilesForm, 'baseJson')">
            </div>
        </div>

        <h3 class="text-lg font-medium mt-8">Target Languages</h3>
        <mat-tab-group class="mt-2" animationDuration="0ms">
            <mat-tab *ngFor="let lang of wizardData.targetLanguages" [label]="lang.toUpperCase()">
                <div class="p-4 border border-t-0 rounded-b-md">
                    <textarea matInput class="w-full h-48 p-2 font-mono border rounded-md bg-gray-50 dark:bg-gray-800" [formControlName]="lang" placeholder='{ "GREETING": "Hola" } or leave empty'></textarea>
                    <div class="flex items-center justify-between mt-2">
                        <mat-error *ngIf="separateFilesForm.get(lang)?.hasError('invalidJson') && separateFilesForm.get(lang)?.touched">Invalid JSON format.</mat-error>
                        <button mat-button (click)="targetFileInput.click()">Upload File</button>
                        <input type="file" #targetFileInput class="hidden" accept=".json" (change)="handleFileInput($event, separateFilesForm, lang)">
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>

    <!-- Mode 2: Single Combined File -->
    <div *ngIf="inputFormat === 'combined'" [formGroup]="combinedFileForm" class="mt-4">
        <h3 class="text-lg font-medium mt-6">Combined Language File</h3>
        <div class="mt-2">
            <textarea matInput class="w-full h-48 p-2 font-mono border rounded-md bg-gray-50 dark:bg-gray-800" formControlName="combinedJson" placeholder='{ "en": { "GREETING": "Hello" }, "es": { "GREETING": "Hola" } }'></textarea>
            <div class="flex items-center justify-between mt-2">
                <mat-error *ngIf="combinedFileForm.get('combinedJson')?.hasError('invalidJson') && combinedFileForm.get('combinedJson')?.touched">Invalid JSON format.</mat-error>
                <button mat-button (click)="combinedFileInput.click()">Upload File</button>
                <input type="file" #combinedFileInput class="hidden" accept=".json" (change)="handleFileInput($event, combinedFileForm, 'combinedJson')">
            </div>
        </div>
    </div>

    <!-- Actions -->
    <div class="flex justify-between mt-8 pt-6 border-t">
        <button mat-stroked-button (click)="onBack()">Back</button>
        <button mat-flat-button color="primary" [disabled]="isFormInvalid()" (click)="onNext()">
            Find Missing Translations
        </button>
    </div>
</div>
